import React from "react";
import { AddNewAccountLoaderTemplate } from "themes/administration/producer/components";

function AddNewAccountLoader(props) {
    return <AddNewAccountLoaderTemplate {...props} />;
}

export default AddNewAccountLoader;
